<div class="file-upload-limitaion">
    <div class="item">
        <span class="dot"></span>
        <span class="text" [translate]="'GENERAL.FILE_UPLOAD_LIMITAION.FORMAT'" [translateParams]="{value: allowedExt}"></span>
    </div>
    <div class="item">
        <span class="dot"></span>
        <span class="text" [translate]="'GENERAL.FILE_UPLOAD_LIMITAION.SIZE'" [translateParams]="{value: fileMaxSize}"></span>
    </div>
</div>